function renderEmailRepeat (country) {
  return `<div class="form-group ui-form__row two_in_row columnfield_">
    <div class="ui-form__field">
      <div class="ui-dropdown-field">
        <div class="ui-input ui-dropdown-field__active ui-input_fade">
          <label class="ui-input__container">
            <div class="ui-input__column">
              <input type="email" name="email_repeat" value="" autocomplete="new-password" autocapitalize="sentences" placeholder="e-mail" data-hj-whitelist class="ui-input__field" data-required>
              <span class="ui-input__label ui-input__label_mark_required">
                <span class="ui-input__label_placeholder-text">Repetir e-mail</span>
                <span class="ui-input__label_placeholder-hint"></span>
              </span>
            </div>
            <div class="ui-input__additional">
            </div>
          </label>
        </div>
      </div>
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">Los campos no coinciden</div>
    </div>
  </div>`
}

export { renderEmailRepeat }